import type { Toast as PrimeToast } from "primereact/toast";
import { forwardRef } from "react";

import type { ToastProps } from "./types-toast";
import { useToastComponent } from "./use-toast";
import { ToastView } from "./view-toast";

/**
 * `Toast` do Prime com largura, `position="top-right"` e, em `ref.show`/`ref.replace`, os ícones por severity do Figma
 * (success-circle 20, demais 18; fechar 16) como padrão: a `icon`/`closeIcon` da mensagem vencem.
 * O `ref` é a instância do Prime (`show`, `replace`, `clear`, `remove`, `getElement`).
 */
export const Toast = forwardRef<PrimeToast, ToastProps>(function Toast(props, ref) {
  const viewModel = useToastComponent(props, ref);

  return <ToastView {...viewModel} />;
});
Toast.displayName = "Toast";
